import { GeometryChangeRetriever } from "./geometryChangeRetriever";
import { GeometryChange } from "./types";
import { Feature, Polygon } from "geojson";
import { getSegmentChanges } from "./segments/segmentChangeRetriever";

export const polygonChangeRetriever: GeometryChangeRetriever = {
    retrieveChange(featureBefore: Feature | undefined, featureNow: Feature): GeometryChange[] {
        return getSegmentChanges(featureBefore as Feature<Polygon>, featureNow as Feature<Polygon>);
    },
};
